module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"error_content":{"title":"The page cannot be displayed.","message":"For some reason the page could not be displayed correctly.\\nIf the page does not display properly after reopening it, please try again later.\\n","alt":"Catch-kun wearing a helmet.","button":"Return to top of list"}}}')
  delete Component.options._Ctor
}
